import { PTB_HOMEPAGE_FEATURED_VIDEO } from "@/lib/constants";
import Feed from "@/modules/community/components/feed";
import FeedCreatePost from "@/modules/community/components/feed/feed-create-post";
import { HomepageRightSidebar } from "@/modules/home/components/product-listing/product-listing";
import "flag-icons/css/flag-icons.min.css";

const CommunityTab = () => {
	return (
		<div className="flex flex-col gap-3 md:gap-4 ">
			<div className="flex items-start justify-center gap-2 max-md:flex-wrap">
				<div className="w-full flex-1 space-y-4 overflow-hidden">
						<FeedCreatePost />
					<Feed />
				</div>
				<div className="min-w-[300px] max-w-[350px] space-y-4 md:block">
					<HomepageRightSidebar
						featuredVideo={PTB_HOMEPAGE_FEATURED_VIDEO}
						enable={{
							onlineUsers: true,
							trendingNewsCard: true,
							createAccountCard: true,
							submitProductCard: true,
						}}
					/>
				</div>
			</div>
		</div>
	);
};

export default CommunityTab;
